<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Modification" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-modification-form [modification]="modification" *ngIf="modification"></app-modification-form>
        </form>
      </div>
    </section>
  </div>
</div>
